import React from "react";
import HomeContainer from "../components/Home/Main/HomeContainer";
import Sidebar from "../components/Home/Sidebar/Sidebar";

function Home() {
  return (
    <div className="container relative">
      <Sidebar />
      <HomeContainer />
    </div>
  );
}

export default Home;
